export enum ActionType {
  NON_ISSUE = 'NON_ISSUE',
}

export interface Action {
  ACTION_TYPE_ID: number
  ACTION_DETAILS: string
  IS_FINAL_ACTION: boolean
  CASE_ID: number
  ACTION_DATE: string
  ACTION_BY: string
}

export interface AvailableAction {
  ACTION_TYPE: string
  ACTION_TYPE_ID: number
  DESCRIPTION: string
  IS_FINAL_ACTION: boolean
}

// Payload used when executing an action against an alert
export interface ActionRequest {
  ACTION_TYPE_ID: number
  ACTION_DETAILS: string
  IS_FINAL_ACTION: boolean
  CASE_ID?: number
}

// Individual action item in bulk request (snake_case for API)
export interface BulkActionItem {
  alert_id: number
  action_type_id: number
  action_details: string
}

// Bulk actions request payload
export interface BulkActionsRequest {
  actions: BulkActionItem[]
}
